/**
 * Composant spécialisé pour l'assessment Training Transformation IA.
 * Charge questions/scores depuis Supabase (slug: transformation-formation-ia).
 */

import React from 'react';
import AssessmentModalGeneric from './AssessmentModalGeneric';
import { useQuestionnaireFromDB } from '@/hooks/useQuestionnaireFromDB';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent } from '@/components/ui/dialog';

interface AssessmentModalAILearningStrategyProps {
  isOpen: boolean;
  onClose: () => void;
  startAtFirstQuestion?: boolean;
}

const AssessmentModalAILearningStrategy: React.FC<AssessmentModalAILearningStrategyProps> = ({
  isOpen,
  onClose,
  startAtFirstQuestion = false,
}) => {
  const { questionnaire, loading, error } = useQuestionnaireFromDB('transformation-formation-ia');

  if (!isOpen) return null;

  if (loading || error || !questionnaire) {
    return (
      <Dialog open={isOpen} onOpenChange={(o) => !o && onClose()}>
        <DialogContent className="max-w-md">
          <div className="flex flex-col items-center justify-center py-10 gap-3">
            {loading ? (
              <>
                <Loader2 className="w-6 h-6 animate-spin text-primary" />
                <p className="text-sm text-muted-foreground">Chargement du diagnostic…</p>
              </>
            ) : (
              <p className="text-sm text-destructive text-center">
                {error ?? 'Diagnostic indisponible pour le moment.'}
              </p>
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  const axisDescriptions: Record<string, string> = {};
  questionnaire.axes.forEach(a => {
    if (a.description) axisDescriptions[a.name] = a.description;
  });

  return (
    <AssessmentModalGeneric
      isOpen={isOpen}
      onClose={onClose}
      startAtFirstQuestion={startAtFirstQuestion}
      assessmentType="training-transformation"
      data={questionnaire.data}
      categoryMapping={questionnaire.categoryMapping}
      axisDescriptions={axisDescriptions}
    />
  );
};

export default AssessmentModalAILearningStrategy;
